import { ErrorToast } from './ErrorToast';
import { useErrorToastStore } from '@/shared/stores/errorToastStore';

export function ErrorToastContainer() {
  const { toasts, removeToast } = useErrorToastStore();

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed top-4 right-4 z-50 flex flex-col gap-3 w-full max-w-md pointer-events-none"
      aria-live="polite"
      aria-atomic="false"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <ErrorToast toast={toast} onClose={() => removeToast(toast.id)} />
        </div>
      ))}
    </div>
  );
}
